import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';

import { hasDeliveryDetails, IOrder, ngHelper } from '@cakeiteasy/web-utils';

import { CART_DELIVERY_TYPES, DELIVERY_ORDER_DELIVERY_TYPES } from '../../../cart/constants/common';

@Component({
  standalone: false,
  selector: 'order-info-partial',
  templateUrl: './order-info-partial.component.html',
  styleUrls: ['./order-info-partial.component.scss']
})
export class OrderInfoPartialComponent implements OnChanges {
  @Input() order: IOrder;
  @Input() isCustomerView = true;

  public isToDoorDelivery = false;
  public isPickupDelivery = false;
  public isGiftDelivery = false;

  public CART_DELIVERY_TYPES = CART_DELIVERY_TYPES;

  ngOnChanges(changes: SimpleChanges) {
    ngHelper.ifChanged(changes, 'order', ({ deliveryOrder }: IOrder) => {
      const { PICKUP, DELIVERY } = CART_DELIVERY_TYPES;
      const { GIFT } = DELIVERY_ORDER_DELIVERY_TYPES;
      // a NO_DELIVERY order carries no delivery information at all
      const showDelivery = hasDeliveryDetails(deliveryOrder);

      this.isGiftDelivery = showDelivery && deliveryOrder.deliveryType === GIFT;
      this.isPickupDelivery = showDelivery && !this.isGiftDelivery && deliveryOrder.type === PICKUP;
      this.isToDoorDelivery = showDelivery && !this.isGiftDelivery && deliveryOrder.type === DELIVERY;
    });
  }
}
